export enum IconType {
    SAPIcons = 'SAP-icons',
    SAPTNTIcons = 'SAP-icons-TNT',
    FontAwesome = 'font-awesome',
    CAD = 'cad'
}
export class NavigationItemModel {
    title: string;
    icon: string;
    iconType: IconType;
    route?: string;
    featureToggle?: string;
    isSelected? = false;
}
